<ng-template #walletItem let-name="name" let-amount="amount" let-showTooltip="showTooltip" let-isMobile="isMobile">
  <div [attr.data-type]="name" class="loyalty-payment-option ps-medium-x">
    <div class="title font-body-2">
      {{ 'oneUpgrade.walletOptions.' + name | finLocalization }}
    </div>

    <div *ngIf="!showTooltip" class="amount font-body-2 bold-type">
      {{ amount }}
    </div>

    <div
      *ngIf="showTooltip"
      class="amount font-body-2 bold-type underline link-hover"
      fcomPopover
      [options]="isMobile ? tooltipOptionsMobile : tooltipOptions"
      [content]="contentTooltip"
      [ariaCloseText]="'welcomeBackMessage.closeText' | finLocalization"
    >
      {{ amount }}
    </div>
  </div>
</ng-template>

<ng-template #walletStatus let-isMobile="isMobile">
  <ng-container *ngIf="availableBenefits$ | async as availableBenefits">
    <ng-container *ngIf="originalBalance$ | async as originalBalance">
      <ng-container
        [ngTemplateOutlet]="walletItem"
        [ngTemplateOutletContext]="{ name: 'points', amount: availableBenefits.points }"
      ></ng-container>
      <ng-container
        *ngIf="!enableUpgradeBenefits"
        [ngTemplateOutlet]="walletItem"
        [ngTemplateOutletContext]="{ name: 'europeVouchers', amount: availableBenefits.EUROPE_UPGRADE }"
      ></ng-container>
      <ng-container
        *ngIf="enableUpgradeBenefits && originalBalance.UPGRADE_BENEFIT"
        [ngTemplateOutlet]="walletItem"
        [ngTemplateOutletContext]="{
          name: 'upgradeBenefits',
          amount: availableBenefits.UPGRADE_BENEFIT,
          showTooltip: true,
          isMobile: isMobile,
        }"
      ></ng-container>
      <ng-container
        *ngIf="originalBalance.LONG_HAUL_UPGRADE"
        [ngTemplateOutlet]="walletItem"
        [ngTemplateOutletContext]="{ name: 'longhaulVouchers', amount: availableBenefits.LONG_HAUL_UPGRADE }"
      ></ng-container>
    </ng-container>
  </ng-container>
</ng-template>

<ng-template #logInText>
  <p class="ps-medium-l login-text">
    {{ 'oneUpgrade.loginPrompt' | finLocalization }}
  </p>
</ng-template>

<ng-template #contentTooltip>
  <h4 class="font-body-1 medium-type nordic-blue-900-text ms-small-b">
    {{ 'oneUpgrade.walletOptions.upgradeBenefitsTooltip.title' | finLocalization }}
  </h4>
  <p class="font-body-1 nordic-blue-900-text ms-small-b">
    {{ 'oneUpgrade.walletOptions.upgradeBenefitsTooltip.para1' | finLocalization }}
  </p>
  <p class="font-body-1 nordic-blue-900-text ms-small-b">
    {{ 'oneUpgrade.walletOptions.upgradeBenefitsTooltip.para2' | finLocalization }}
  </p>
  <p class="font-body-1 nordic-blue-900-text">
    {{ 'oneUpgrade.walletOptions.upgradeBenefitsTooltip.para3' | finLocalization }}
  </p>
</ng-template>

<div class="is-hidden" #toasterContent>
  <h4 class="font-body-1 medium-type nordic-blue-900-text ms-small-b">
    {{ 'oneUpgrade.walletOptions.upgradeBenefitsTooltip.title' | finLocalization }}
  </h4>
  <p class="font-body-1 nordic-blue-900-text ms-small-b">
    {{ 'oneUpgrade.walletOptions.upgradeBenefitsTooltip.para1' | finLocalization }}
  </p>
  <p class="font-body-1 nordic-blue-900-text ms-small-b">
    {{ 'oneUpgrade.walletOptions.upgradeBenefitsTooltip.para2' | finLocalization }}
  </p>
  <p class="font-body-1 nordic-blue-900-text">
    {{ 'oneUpgrade.walletOptions.upgradeBenefitsTooltip.para3' | finLocalization }}
  </p>
</div>

<div
  class="status-wrapper relative grid-max-width grid-col-12 nordic-blue-900-bg ps-xsmall-y"
  [class.logged-in]="loggedIn$ | async"
  [class.is-open]="accordionOpen"
>
  <div class="col-1-12 flex flex--space-between">
    <div class="flex flex--center">
      <fin-booking-header-summary
        *ngIf="bookingSummary$ | async as bookingSummary"
        [bookingSummary]="bookingSummary"
      ></fin-booking-header-summary>
    </div>

    <div class="flex white-text">
      <div class="flex flex--center border-left dn-laptop-down padding-wrapper">
        <ng-container
          [ngTemplateOutlet]="(loggedIn$ | async) ? walletStatus : logInText"
          [ngTemplateOutletContext]="{ isMobile: false }"
        ></ng-container>
      </div>

      <button
        data-testid="upgrade-modal-open-button"
        (click)="openHelpModal($event)"
        class="pr-xsmall-x dn-laptop-down grow focus-inset help"
        type="button"
        [attr.aria-label]="'oneUpgrade.helpModal.ariaOpenButton' | finLocalization"
        data-id="help-modal-button"
      >
        <fcom-icon class="icon-medium" [name]="SvgLibraryIcon.HELP_OUTLINE"></fcom-icon>
      </button>

      <div class="wallet-button flex grow border-left">
        <button
          (click)="toggleWallet()"
          class="focus-inset dn-laptop-up"
          [attr.aria-expanded]="accordionOpen"
          [attr.aria-label]="
            (accordionOpen ? 'oneUpgrade.statusBar.closeWallet' : 'oneUpgrade.statusBar.openWallet') | finLocalization
          "
          type="button"
        >
          <fcom-icon
            *ngIf="accordionOpen; else walletIcon"
            class="icon-medium"
            [name]="SvgLibraryIcon.CLOSE_DELETE"
          ></fcom-icon>
        </button>

        <span class="flex flex--center dn-laptop-down">
          <ng-container [ngTemplateOutlet]="walletIcon"></ng-container>
        </span>
      </div>
    </div>
  </div>
</div>

<ng-template #walletIcon>
  <fcom-icon
    class="icon-medium"
    [name]="(loggedIn$ | async) ? SvgLibraryIcon.WALLET_OPEN : SvgLibraryIcon.WALLET_CLOSED"
  ></fcom-icon>
</ng-template>

<div
  #statusAccordion
  class="wallet-accordion overflow-hidden relative grid-max-width grid-col-12"
  [class.logged-in]="loggedIn$ | async"
  [attr.aria-hidden]="!accordionOpen"
  [class.is-open]="accordionOpen"
>
  <div class="col-1-12 white-text" [ngClass]="(loggedIn$ | async) ? 'ps-xxsmall-y' : 'ps-xsmall-y'">
    <div class="flex relative" [ngClass]="{ 'flex--space-between flex--align-start': (loggedIn$ | async) === false }">
      <div class="flex flex-1 accordion-options">
        <ng-container
          [ngTemplateOutlet]="(loggedIn$ | async) ? walletStatus : logInText"
          [ngTemplateOutletContext]="{ isMobile: true }"
        ></ng-container>
      </div>

      <button
        (click)="openHelpModal($event)"
        [attr.aria-label]="'oneUpgrade.helpModal.ariaOpenButton' | finLocalization"
        class="accordion-help-button"
        type="button"
      >
        <fcom-icon class="icon-medium" [name]="SvgLibraryIcon.HELP_OUTLINE"></fcom-icon>
      </button>
    </div>
  </div>
</div>

<div #walletOverlay (click)="toggleWallet()" class="wallet-overlay grow--pos fill--pos fixed"></div>
